<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{on, attrs}">
        <span v-bind="attrs" v-on="on"><v-icon>mdi-translate</v-icon> {{ $t("language") }}</span>
      </template>
      <v-list v-for="lang of languages" :key="lang.value" dense>
        <v-list-item  @click="switchLanguage(lang.value)">{{lang.text}}</v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator"
import {config, utils} from "@/libs/utils"
@Component({})
export default class ChangeLanguage extends Vue {

  languages = config.VUE_APP_LANGUAGES 

  constructor() {
    super()
  }

  created() {
    const savedLanguage = localStorage.getItem("user-language")
    if (savedLanguage) {
      this.$i18n.locale = savedLanguage
    }
  }

  switchLanguage(lang: string) {
    this.$i18n.locale = lang
    localStorage.setItem("user-language", lang)
    //reload the page with same url
    utils.showSnackbarInfo(this.$t("changing-launchage").toString())
    //setup mask to cover the screen while reloading
    utils.showMask()
    window.location.reload()
  }
}
</script>
